/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planninghorizon1Inputs */

const en_planninghorizon1 = /** @type {(inputs: Planninghorizon1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planning horizon`)
};

const de_planninghorizon1 = /** @type {(inputs: Planninghorizon1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planungshorizont`)
};

/**
* | output |
* | --- |
* | "Planning horizon" |
*
* @param {Planninghorizon1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planninghorizon1 = /** @type {((inputs?: Planninghorizon1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planninghorizon1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planninghorizon1(inputs)
	return de_planninghorizon1(inputs)
});
export { planninghorizon1 as "planningHorizon" }